import React, { Fragment } from "react";
import Alert from "../layouts/Alert";
import AccountHeader from "../layouts/AccountHeader";
import "../../styles/index.css";

const AccountTemplate = (props) => {
  return (
    <Fragment>
      <AccountHeader
        history={props.children.props.history}
        location={props.children.props.location}
        match={props.children.props.match}
      />
      <div className='bg-dark p-0 fullheight'>
        <div className='mx-auto w-75-condition '>
          <div className='py-4' style={{ minWidth: "280px" }}>
            <Alert />
            {props.children}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AccountTemplate;
